import React from 'react';
import take from 'lodash/take';
import { observer, inject } from 'mobx-react';
import injectSheet from 'react-jss';
import EmoteBarAction from './emoteBarAction';
import Emote from './Emote';
import { takeEmotesbarStore } from './enhancers';

@inject('store') @observer
class EmotesBar extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      playing: true,
      paused: false,
      emotes: []
    }

    this.toggleEmoteFlow = this.toggleEmoteFlow.bind(this)
  }

  toggleEmoteFlow () {
    this.setState({
      playing: !this.state.playing,
      paused: !this.state.paused,
      emotes: _.take(this.props.store.emotesBar, 15)
    })
  }

  render () {
    const {classes, store} = this.props;
    const {emotesBar} = store;
    return (
      <div className={classes.emotesBarWrapper} onClick={this.toggleEmoteFlow}>
        <EmoteBarAction isPlaying={this.state.playing} onClick={this.toggleEmoteFlow}/>
        <div className={classes.emotesBar}>
          {
            this.state.playing &&
            emotesBar.map((emote) => (
              <Emote key={emote.key} iconSrc={emote.emote}/>
            ))
          }
          {
            this.state.paused && this.state.emotes.map((emote, k) => (
              <Emote key={emote.key} iconSrc={emote.emote}/>
            ))
          }
        </div>
      </div>
    )
  }
}

const styles = theme => ( {
  emotesBarWrapper: {
    position: 'relative'
  },
  emotesBar: {
    ...theme.card,
    display: 'flex',
    flexDirection: 'row-reverse',
    height: theme.channelItems.emotesBar.height,
    overflow: 'hidden',
    width: '100%',
    marginBottom: theme.spacing
  }
} )

export default injectSheet(styles)(EmotesBar)



// WEBPACK FOOTER //
// ./src/app/components/emotesBar/EmotesBar.js